import { useQuery } from '@tanstack/react-query';
import { catalogImageService } from '@/services/catalogImageService';
import { queryKeys } from '@/lib/queryKeys';

export const useCatalogImageMetadata = (catalogId?: string | null) => {
  return useQuery({
    queryKey: queryKeys.catalog.imageMetadata(catalogId ?? ''),
    queryFn: () => catalogImageService.getMetadata(catalogId!),
    enabled: Boolean(catalogId),
    staleTime: 60_000,
  });
};
